import classnames from 'classnames'
import { __ } from '@wordpress/i18n'
import { compose } from '@wordpress/compose'
import {
	addFilter,
	applyFilters
} from '@wordpress/hooks'
import {
	PanelBody,
	RangeControl,
	ToggleControl,
	SelectControl,
	Disabled
} from '@wordpress/components'
import {
	Fragment
} from '@wordpress/element'
import {
	DesignPanelBody
} from '~cartzillagb/components'
import {
	ProductAttributeTermControl,
	ProductCategoryControl,
	ProductTagControl,
	ProductsControl
} from '~cartzillagb/components/woocommerce/components'
import {
	withTabbedInspector,
} from '~cartzillagb/higher-order'
import PanelImage  from  './images/panel-image.png'
import { i18n } from 'cartzillagb'

import Block from './block'

addFilter( 'cartzillagb.products.edit.inspector.layout.before', 'cartzillagb/products', ( output, props ) => {
	const {
		attributes,
		setAttributes
	} = props

	const {
		design,
	} = attributes

	return (
		<DesignPanelBody
			title={ __( 'Layout', i18n ) }
			initialOpen={ true }
			selected={ design }
			options={ applyFilters( 'cartzillagb.products.edit.inspector.design', [
				{
					label: __( 'WooCommerce', i18n ), value: 'style-v1', image: PanelImage,
				},
				{
					label: __( 'Market Place', i18n ), value: 'style-v2', image: PanelImage,
				},
				{
					label: __( 'Grocery', i18n ), value: 'style-v3', image: PanelImage,
				},
			] ) }
			onChange={ design => {
				setAttributes( { design } )
			} }
		/>
	)
} )

addFilter( 'cartzillagb.products.edit.inspector.style.before', 'cartzillagb/products', ( output, props ) => {
	const {
		attributes,
		setAttributes
	} = props

	const {
		type,
		limit,
		columns,
		orderby,
		order,
		onSale,
		bestSelling,
		topRated,
		products,
		categories,
		catOperator,
		tags,
		tagOperator,
		attribute,
		attrOperator,
		visibility,
		exclude,
	} = attributes

	const PanelOptions = ( ! ( exclude && exclude.includes('type') ) ) ? {
		selected: type,
		options: applyFilters( 'cartzillagb.products.edit.inspector.type', [
			{
				label: __( 'Default', i18n ), value: 'default', image: PanelImage,
			},
			{
				label: __( 'Categories', i18n ), value: 'categories', image: PanelImage,
			},
			{
				label: __( 'Tags', i18n ), value: 'tags', image: PanelImage,
			},
			{
				label: __( 'Products', i18n ), value: 'products', image: PanelImage,
			},
			{
				label: __( 'Attributes', i18n ), value: 'attributes', image: PanelImage,
			},
		] ),
		onChange: type => {
			setAttributes( { type } )
		}
	} : {}

	return (
		<Fragment>
			<DesignPanelBody
				title={ __( 'General', i18n ) }
				initialOpen={ true }
				{ ...PanelOptions }
			>
				{ ! ( exclude && exclude.includes('orderby') ) &&
					<SelectControl
						label={ __( 'Orderby', i18n ) }
						value={ orderby }
						options={ [
							{ value: 'date', label: __( 'Date', i18n ) },
							{ value: 'id', label: __( 'ID', i18n ) },
							{ value: 'menu_order', label: __( 'Menu Order', i18n ) },
							{ value: 'popularity', label: __( 'Popularity', i18n ) },
							{ value: 'rand', label: __( 'Random', i18n ) },
							{ value: 'rating', label: __( 'Rating', i18n ) },
							{ value: 'title', label: __( 'Title', i18n ) },
						] }
						onChange={ orderby => setAttributes( { orderby } ) }
					/>
				}
				{ ! ( exclude && exclude.includes('order') ) &&
					<SelectControl
						label={ __( 'Order', i18n ) }
						value={ order }
						options={ [
							{ value: 'ASC', label: __( 'ASC', i18n ) },
							{ value: 'DESC', label: __( 'DESC', i18n ) },
						] }
						onChange={ order => setAttributes( { order } ) }
					/>
				}
				{ ! ( exclude && exclude.includes('limit') ) &&
					<RangeControl
						label={ __( 'Limit', i18n ) }
						value={ limit }
						onChange={ limit => setAttributes( { limit } ) }
						min={ 1 }
						max={ applyFilters( 'cartzillagb.products.edit.inspector.max.limit', 30 ) }
					/>
				}
				{ ! ( exclude && exclude.includes('columns') ) &&
					<RangeControl
						label={ __( 'Columns', i18n ) }
						value={ columns }
						onChange={ columns => setAttributes( { columns } ) }
						min={ 1 }
						max={ applyFilters( 'cartzillagb.products.edit.inspector.max.columns', 8 ) }
					/>
				}
				{ type === 'default' && (
					<Fragment>
						<ToggleControl
							label={ __( 'On Sale', i18n ) }
							checked={ onSale }
							onChange={ onSale => setAttributes( {
								onSale,
								bestSelling: false,
								topRated: false
							} ) }
						/>
						<ToggleControl
							label={ __( 'Best Selling', i18n ) }
							checked={ bestSelling }
							onChange={ bestSelling => setAttributes( {
								bestSelling,
								onSale: false,
								topRated: false
							} ) }
						/>
						<ToggleControl
							label={ __( 'Top Rated', i18n ) }
							checked={ topRated }
							onChange={ topRated => setAttributes( {
								topRated,
								onSale: false,
								bestSelling: false
							} ) }
						/>
						<ToggleControl
							label={ __( 'Featured', i18n ) }
							checked={ visibility === 'featured' ? true : false }
							onChange={ visibility => setAttributes( { visibility: visibility ? 'featured' : 'visible' } ) }
						/>
					</Fragment>
				) }
			</DesignPanelBody>
			{ type === 'categories' && (
				<PanelBody title={ __( 'Filter by Product Category', i18n ) } initialOpen={ false }>
					<ProductCategoryControl
						selected={ categories }
						onChange={ ( value = [] ) => {
							const ids = value.map( ( { id } ) => id )
							setAttributes( { categories: ids } )
						} }
						operator={ catOperator }
						onOperatorChange={ ( value = 'any' ) =>
							setAttributes( { catOperator: value } )
						}
					/>
				</PanelBody>
			) }
			{ type === 'tags' && (
				<PanelBody title={ __( 'Filter by Product Tag', i18n ) } initialOpen={ false }>
					<ProductTagControl
						selected={ tags }
						onChange={ ( value = [] ) => {
							const ids = value.map( ( { id } ) => id )
							setAttributes( { tags: ids } )
						} }
						operator={ tagOperator }
						onOperatorChange={ ( value = 'any' ) =>
							setAttributes( { tagOperator: value } )
						}
					/>
				</PanelBody>
			) }
			{ type === 'products' && (
				<PanelBody title={ __( 'Filter by Products', i18n ) } initialOpen={ false }>
					<ProductsControl
						selected={ products }
						onChange={ ( value = [] ) => {
							const ids = value.map( ( { id } ) => id )
							setAttributes( { products: ids } )
						} }
					/>
				</PanelBody>
			) }
			{ type === 'attributes' && (
				<PanelBody title={ __( 'Filter by Product Attribute', i18n ) } initialOpen={ false }>
					<ProductAttributeTermControl
						selected={ attribute }
						onChange={ ( value = [] ) => {
							/* eslint-disable camelcase */
							const result = value.map(
								( { id, attr_slug } ) => ( {
									id,
									attr_slug,
								} )
							)
							/* eslint-enable camelcase */
							setAttributes( { attribute: result } )
						} }
						operator={ attrOperator }
						onOperatorChange={ ( value = 'any' ) =>
							setAttributes( { attrOperator: value } )
						}
					/>
				</PanelBody>
			) }
		</Fragment>
	)
} )

const edit = props => {

	const {
		className,
		attributes,
	} = props

	if( ! ( attributes.placeholder > 0 ) ) {
		delete attributes.placeholder
	}

	const output = (
		<div className={ classnames( [
			className,
		], {} ) }>
			<Disabled>
				<Block attributes={ { ...attributes } } />
			</Disabled>
		</div>
	)

	return output
}

export default compose(
	withTabbedInspector( [ 'layout', 'style', 'advanced' ] ),
)( edit )